import React from "react";
import { Row, Col, Collapse, CardBody } from "reactstrap";
import { formatDate } from "../../../Utils/format-date.js";
import { addClassName } from "../../../Utils/Add-ClassName.js";
import { calcPercentage } from "../../../Utils/calculate-progress.js";
import RenderModals from "../../Modals/modal";
import EditModal from "../Sent/Invitation-Modal/Edit-Modal/EditModal";
import DeleteModal from "../Sent/Invitation-Modal/Delete-Modal/DeleteModal";
import editIcon from "../../../../images/new-images/edit-green.svg";
import editdisable from "../../../../images/new-images/edit-disable.svg";
import deleteIcon from "../../../../images/new-images/delete.svg";
import reminderIcon from "../../../../images/new-images/reminder-blue.svg";
import completed from "../../../../images/new-images/completed.png";
import reminderDisableIcon from "../../../../images/new-images/reminder-disable.svg";
import RenderinviteRespondantsModal from "../Sent/Invitation-Modal/Invite-respondants-modal/index";
import "./Sent-Tab.css";
import Buttons from "../Sent/Buttons/Buttons";
import MyinvitationsEmpty from "../Invitations-Empty";
import Renderconfirmmessagemodal from "../Sent/Invitation-Modal/confirm-modal/index.jsx";

const ResponsiveSentRespondantsFiltered = (props) => {

    const editButtonControll = (
        respondentRelationship,
        groupId,
        uid,
        rid,
        respondentEmail,
        is_submited
    ) => {
        if (is_submited === true) {
            return <img style={{ cursor: "not-allowed" }} src={editdisable} />;
        } else {
            return (
                <div>
                    <img
                        onClick={() =>
                            props.handleEditModal(
                                respondentEmail,
                                respondentRelationship,
                                uid,
                                rid,
                                groupId
                            )
                        }
                        src={editIcon}
                    />
                    <RenderModals
                        assessmentModal={props.editModal}
                        handleModalClose={props.handleModalClose}
                        modalHeading="EDIT RELATIONSHIP"
                    >
                        <EditModal
                            handleEditModalSubmit={props.handleEditModalSubmit}
                            respondentEmail={props.respondentEmail}
                            respondentRelationship={props.respondentRelationship}
                            dropDownOptions={props.dropDownOptions}
                            assessmentUserId={props.assessmentUserId}
                            accessorGroupId={props.accessorGroupId}
                            relationShipId={props.relationShipId}
                            handleModalClose={props.handleModalClose}
                            filteredSentRespondants={props.filteredSentRespondants}
                            handleDropdownOptions={props.handleDropdownOptions}
                            sentRespondantsId={props.sentRespondantsId}
                            sentRespondantsFilteredId={props.sentRespondantsFilteredId}
                        />
                    </RenderModals>
                </div>
            );
        }
    };

    const reminderButtonControll = (
        getStatus,
        userId,
        respondantsId,
        respondantEmail
    ) => {
        if (getStatus === "Completed" || getStatus === "In progress") {
            return (
                <img
                    style={{ cursor: "not-allowed", opacity: "0.3" }}
                    src={reminderDisableIcon}
                />
            );
        } else {
            return (
                <img
                    src={reminderIcon}
                    onClick={() =>
                        props.handleReminder(userId, respondantsId, respondantEmail)
                    }
                />
            );
        }
    };

    return (
        <div className="resopnsive-sent-tab">
            <Buttons
                respondantStatus={props.respondantStatus}
                handleInvitationsModal={props.handleInvitationsModal}
                minRespondants={props.minRespondants}
                sentRespondants={props.sentRespondants}
                getRespondantStatus={props.getRespondantStatus}
                getUrlString={props.getUrlString}
                batchMinRespondants={props.batchMinRespondants}
                sentRespondantsId={props.sentRespondantsId}
                filteredSentRespondants={props.filteredSentRespondants}
                idOfParticipant={props.idOfParticipant}
            />

            <RenderModals
                assessmentModal={props.respondentInvitationsModal}
                handleModalClose={props.handleModalClose}
                modalHeading="INVITE RESPONDENT"
            >
                <RenderinviteRespondantsModal
                    inputFields={props.inputFields}
                    handleInputFields={props.handleInputFields}
                    handleRelationDropdown={props.handleRelationDropdown}
                    dropDownOptions={props.dropDownOptions}
                    handleInvitationsEmail={props.handleInvitationsEmail}
                    isChecked={props.isChecked}
                    isDisabled={props.isDisabled}
                    handleModalFormSubmit={props.handleModalFormSubmit}
                    handleModalSubmit={props.handleModalSubmit}
                    handleModalClose={props.handleModalClose}

                />
            </RenderModals>

            <RenderModals
                assessmentModal={props.respondantConfirmModal}
                handleModalClose={props.handleModalClose}
                modalHeading="RESPONDENT DETAILS"
            >
                <Renderconfirmmessagemodal
                    handleModalClose={props.handleModalClose}
                    invitationsSuccessMessage={props.invitationsSuccessMessage}
                />
            </RenderModals>

            {(props.filteredSentRespondants &&
                props.filteredSentRespondants.length == 0) ||
                props.getRespondantStatus.length == 0 ? (
                <MyinvitationsEmpty emptyText="You do not have any respondants yet." />
            ) : (
                <React.Fragment>
                    {props.filteredSentRespondants &&
                        props.filteredSentRespondants.respondents.map(
                            (respondentData, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Row className="justify-content-between mx-0 pt-2">
                                            {respondentData.respondent__full_name == null || respondentData.respondent__full_name == '' ? (
                                                <p className="head-name">
                                                    {respondentData.respondent__email}
                                                </p>
                                            ) : (
                                                <p className="head-name">
                                                    {respondentData.respondent__full_name}
                                                </p>
                                            )}
                                            <i onClick={() => props.toggleCollapse(respondentData.id)}
                                                className={props.collapseID === respondentData.id ? "fas fa-angle-up" : "fa fa-angle-down"}
                                                aria-hidden="true" style={{ marginLeft: '10px' }} />
                                        </Row>
                                        <hr />
                                        <Collapse isOpen={props.collapseID === respondentData.id}>
                                            <CardBody style={{ padding: "5px" }}>
                                                {respondentData.respondent__full_name == null || respondentData.respondent__full_name == '' ? ('') : (
                                                    <Row>
                                                        <Col xs="4" className="title">Email</Col>
                                                        <Col xs="8" className="info">
                                                            {respondentData.respondent__email}
                                                        </Col>
                                                    </Row>
                                                )}
                                                <Row>
                                                    <Col xs="4" className="title">Relationship</Col>
                                                    <Col xs="8" className="info">
                                                        {respondentData.assessor_group__assessor_name}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs="4" className="title">Date of Expiry</Col>
                                                    <Col xs="8" className="info">
                                                        {formatDate(
                                                            respondentData.user_assessment__expiry_date
                                                        )}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col xs="4" className="title">Status</Col>
                                                    <Col xs="8">
                                                        {respondentData.assessment_status__status_name ===
                                                            "In progress" ? (
                                                            <div
                                                                style={{ display: "flex" }}
                                                                className={
                                                                    "assessment-status-text " +
                                                                    addClassName(
                                                                        respondentData.assessment_status__status_name
                                                                    )
                                                                }
                                                            >
                                                                {respondentData.assessment_status__status_name}
                                                                {calcPercentage(
                                                                    respondentData.user_assessment__assessment_number_count,
                                                                    respondentData.respondent_completed_count
                                                                )}
                                                            </div>
                                                        ) : respondentData.assessment_status__status_name ===
                                                            "Completed" ? (
                                                            <div
                                                                className={
                                                                    "assessment-status-text " +
                                                                    addClassName(
                                                                        respondentData.assessment_status__status_name
                                                                    )
                                                                }
                                                            >
                                                                {respondentData.assessment_status__status_name}
                                                                <img src={completed} alt="Completed Image" />
                                                            </div>
                                                        ) : (
                                                            <div
                                                                className={
                                                                    "assessment-status-text " +
                                                                    addClassName(
                                                                        respondentData.assessment_status__status_name
                                                                    )
                                                                }
                                                            >
                                                                {respondentData.assessment_status__status_name}
                                                            </div>
                                                        )}
                                                    </Col>
                                                </Row>
                                                <hr />
                                                <Row className="actions">
                                                    <div className="edit-Icon">
                                                        {respondentData.assessment_status__status_name !== "Completed" &&
                                                            respondentData.assessment_status__status_name !== "In progress" ? (
                                                            editButtonControll(
                                                                respondentData.assessor_group__assessor_name,
                                                                respondentData.assessor_group__id,
                                                                respondentData.user_assessment__id,
                                                                respondentData.id,
                                                                respondentData.respondent__email,
                                                                respondentData.is_submited,
                                                                respondentData.assessment_status__status_name
                                                            )
                                                        ) : (
                                                            <img
                                                                src={editdisable}
                                                                style={{ opacity: "0.3", cursor: "not-allowed" }}
                                                            />
                                                        )}
                                                    </div>

                                                    <img
                                                        onClick={() =>
                                                            respondentData.assessment_status__status_name !== "Completed" &&
                                                                respondentData.assessment_status__status_name !== "In progress" &&
                                                                !respondentData.is_admin_created
                                                                ? props.handleDeleteModal(
                                                                    respondentData.respondent__email,
                                                                    respondentData.user_assessment__id,
                                                                    respondentData.id
                                                                )
                                                                : null
                                                        }
                                                        className="delete-Icon"
                                                        src={deleteIcon}
                                                        style={{
                                                            opacity:
                                                                respondentData.assessment_status__status_name === "Completed" ||
                                                                    respondentData.assessment_status__status_name === "In progress" ||
                                                                    respondentData.is_admin_created
                                                                    ? "0.3"
                                                                    : "1",
                                                            cursor:
                                                                respondentData.assessment_status__status_name === "Completed" ||
                                                                    respondentData.assessment_status__status_name === "In progress" ||
                                                                    respondentData.is_admin_created
                                                                    ? "not-allowed"
                                                                    : "pointer",
                                                        }}
                                                    />

                                                    <RenderModals
                                                        assessmentModal={props.deleteModal}
                                                        handleModalClose={props.handleModalClose}
                                                        modalHeading="DELETE RESPONDENT"
                                                    >
                                                        <DeleteModal
                                                            handleModalClose={props.handleModalClose}
                                                            handleDeleteRequest={
                                                                props.handleDeleteRequest
                                                            }
                                                            respondentEmail={props.respondentEmail}
                                                            respondantUserAssessmentId={
                                                                props.respondantUserAssessmentId
                                                            }
                                                            respondantIndividualId={
                                                                props.respondantIndividualId
                                                            }
                                                        />
                                                    </RenderModals>
                                                    <div className="reminder-Icon">
                                                        {reminderButtonControll(
                                                            respondentData.assessment_status__status_name,
                                                            respondentData.respondent__email,
                                                            respondentData.user_assessment__id,
                                                            respondentData.respondent__id
                                                        )}
                                                    </div>
                                                </Row>
                                            </CardBody>
                                        </Collapse>
                                    </React.Fragment>
                                );
                            }
                        )}
                </React.Fragment>
            )}
        </div>
    );
};

export default ResponsiveSentRespondantsFiltered;



// WEBPACK FOOTER //
// ./src/new/Components/Invitations/Responsive/SentRespondantsFiltered.jsx